import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const DES_AES_IDEA_RC4_Module = () => (
  <QPhototModuleSubtopic
    title="DES, AES, IDEA, Block Cipher Operation, RC4"
    videos={[
      "https://www.youtube.com/embed/eMHcQByhR-g",
      "https://www.youtube.com/embed/vj7HJ56mdiw",
      "https://www.youtube.com/embed/v8G4UllT9dc",
      "https://www.youtube.com/embed/YVT4fcW7sI8",
      "https://www.youtube.com/embed/iOE_3GW0njg",
      "https://www.youtube.com/embed/On_OMBf2j6E",
      "https://www.youtube.com/embed/OcSUWAYBPZs",
      "https://www.youtube.com/embed/lRyzKIvxNdM"
    ]}
    takeaways={[]}
    questions={[
      {
        text:
          "Draw an architecture of RC4 algorithm and discuss the process of initialization, initial state permutation, key stream generation and encryption in detail"
      },
      {
        text: "Explain the DES feistel structure in detail with neat diagram."
      },
      {
        text:
          "Answer the following questions about S-boxes in DES:\ni) Show the result of passing the input 111111 through S-box 2.\nii) Show the result of passing the input 000000 through S-box 7(in the exam papers tables will be given)."
      },
      {
        text:
          "Find the third round key of AES 128 using the following second round key which is given in hexadecimal, S-Box table and round constant 04.(in the exam s-box table will be given).",
          image:"/cns_5.png"
      },
      {
        text:
          "Explain in detail the state and key initialization, initial state permutation, key stream generation and encryption process of RC4 algorithm with diagram and algorithm steps"
      },
      {
        text:
          "Construct the shift row matrix from the given sub byte matrix (given in Hex) in AES algorithm. Also, find X and Y values in the given output of mix column matrix using the given fixed matrix and determined shift row matrix (Hint: when finding X & Y values, consider fixed matrix as first matrix and shift row matrix as second matrix)",
          image:"/cns_6.png"
      },
      {
        text:
          "Describe the operation of S-Box group and S-Box rule. Also, Find the output of S box group from the output of the whitener (XOR) operation of DES function using given S-Box tables. The output of the whitener is 48-bit values, which serves as the input to the S-boxes. The 48-bit values are given as follows:\n11001110101001100111011000001111100010101101111"
      },
      {
        text:
          "Agroup of individuals is preparing to march in a parade. If three people are\nlined up in a row, one person is left over. If they line up four toa row, two\npeople are left over, and three people are left over if they line up five to a\nrow. What is the smallest group size that can be accommodated? What is 10\nthe least number youcan come up with?\nApply Chinese Reminder Theorem"
      },
      {
        text:
          "State and prove the Fermat's theorem. Also compute 312 mod 11 using\nFermat's Theorem."
      },
      {
        text:
          "Define Euler's totient function. Prove that ø (n) = pq for n = pq where\np and q are prime numbers such that p is not equal to q."
      },
      {
        text:
          "Consider a block cipher using 8-bit blocks that is based on the basic DES\narchitecture (Feistel network) with two rounds and no initial or final\npermutation. The scrambling function for round I is fi (x, K) = (2i.K)^x mod\n15, for i=1, 2, where the key K is a member of Z15\nIf K= 7 and the ciphertext is 00111111, what is the plaintext and show your intermediate results where, . is Multiplication of the function f"
      },
      {
        text:
          "Design and explain the cryptosystem composed of 12 rounds with an input\nblock of size 128 bits and a key length of 128 bits that can resist the known\ncipher text attacks and satisfies the diffusion and confusion properties."
      },
      {
        text:
          "Implement the Stream cipher RC4 algorithm for the State vector S initialized with values ranging from 0 to 7 where the Key K is [1 2 3 5] and the plaintext P is given by [ 1 2 3 2]. Find out the cipher bistream C."
      },
      {
        text:
          "Find the plain text using SDES decryption for the following cipher text 0111 0111.Let the key for Round1 K1 and key for Round K2 be 1010 0100 and 0100 0011 respectively.",
          image:"/cns_7.png"
      },
      {
        text:
          "Consider a Feistel cipher composed of 16 rounds with a block length of 128\nbits and a key length of 128 bits. Suppose that, for a given k, the key\nscheduling algorithm determines values for the first 8 round keys, k1, k2, ...,\nk8, and then sets k9 = k8, k10 = k7, k11 = k6, ..., k16 = k1\nSuppose you have a ciphertext c. Explain how, with access to an encryption\nresult, you can decrypt ‘c’ and determine the plain text ‘m’ using just a single\nexpression."
      },
      {
        text:
          "Implement the Stream Cipher RC4 algorithm for the State vector S = 8 x 3-bits\nwhere the Key K = [1 2 3 6] and the Plaintext P = [1 2 2 2]. Find out the Cipher\ntext C."
      }
    ]}
    exampleVideos={[]}
  />
);

export default DES_AES_IDEA_RC4_Module;
